export default (builder) =>
  builder.query({
    query: ({ org, link }) => ({
      url: `/scraper/job?org=${org}&jobUrl=${link}`,
      method: 'GET',
    }),
  });
